import { gsap } from 'gsap';

const popUpBtns = document.querySelectorAll('.products__btn');
const popUp = document.querySelectorAll('.popup');
const popUpContent = document.querySelectorAll('.popup__container');
const closeBtn = document.querySelector('.popup__close');
const closeWrapper = document.querySelector('.popup__wrapper');
const header = document.querySelector('.l-header');
const body = document.querySelector('html');

const popUpSlider = document.querySelector('.popup__slider');
const popUpSliderThumb = document.querySelector('.popup__thumb');
const popUpSliderName = document.querySelector('.popup__name');
const popupDetail = document.querySelector('.popup__detail');
const popupDetails = document.querySelectorAll('.popup__detail');
const popUpSliderHeight = popUpSlider.offsetHeight;
const popUpSliderThumbHeight = popUpSliderThumb.offsetHeight;
const popUpSliderNameHeight = popUpSliderName.offsetHeight;

class PopUp {
  openFlag = false;

  constructor() {
    this.events();
    this.detailHeight();
  }

  // イベント
  events() {
    popUpBtns.forEach((btn) =>
      btn.addEventListener('click', this.onClickDispatcher.bind(this))
    );
    closeBtn.addEventListener('click', this.onClickDispatcher.bind(this));
    closeWrapper.addEventListener('click', this.onClickDispatcher.bind(this));
  }

  // メソッド
  detailHeight() {
    console.log(
      popUpSliderHeight,
      popUpSliderThumbHeight,
      popUpSliderNameHeight
    );
    const popUpSliderDetailHeight =
      popUpSliderHeight - popUpSliderThumbHeight - popUpSliderNameHeight;
    console.log(
      popUpSliderHeight,
      popUpSliderThumbHeight,
      popUpSliderNameHeight,
      popUpSliderDetailHeight
    );
    popupDetails.forEach(
      // (el) => console.log(el.style.height)
      (el) => (el.style.height = popUpSliderDetailHeight - 100 + 'px')
    );
    // popupDetail.style.height = popUpSliderDetailHeight - 50 + 'px';
  }

  onClickDispatcher() {
    if (this.openFlag === false) {
      this.popUpOpen();
    } else if (this.openFlag === true) {
      this.popUpClose();
    }
  }

  popUpOpen() {
    const TL = gsap.timeline();
    TL.to(popUp, {
      autoAlpha: 1,
      duration: 0.4,
      ease: 'power4.out',
    }).to(
      popUpContent,
      {
        right: '0',
        duration: 0.3,
      },
      '-=0.2'
    );
    body.classList.add('body-no-scroll');
    this.openFlag = true;
  }

  popUpClose() {
    const TL = gsap.timeline();
    TL.to(popUpContent, {
      right: '-100%',
      duration: 0.3,
    }).to(
      popUp,
      {
        autoAlpha: 0,
        duration: 0.4,
        ease: 'power4.out',
      },
      '-=0.2'
    );
    body.classList.remove('body-no-scroll');
    this.openFlag = false;
  }
}

export default PopUp;
